/**
 * Mapeamento de códigos de erro de autenticação para mensagens amigáveis
 *
 * Estes erros são lançados pelo NextAuth durante o processo de login
 * e capturados no client-side para exibir ao usuário
 */

export const AUTH_ERROR_MESSAGES: Record<string, string> = {
  // Erros customizados (InvalidLoginError em auth.config.ts)
  userNotLinkedToStoreError:
    "Usuário não está vinculado a nenhuma empresa. Entre em contato com o administrador.",

  userHasAccess:
    "Você não tem permissão para acessar o sistema neste dia da semana.",

  userNotWithinAllowedTimeRange:
    "Você não tem permissão para acessar o sistema neste horário.",

  userIpNotAllowed:
    "Seu endereço IP não tem permissão para acessar o sistema. Entre em contato com o administrador.",

  authError: "Credenciais inválidas. Verifique seu e-mail e senha.",

  // Erros padrão do NextAuth
  CredentialsSignin: "Credenciais inválidas. Verifique seu e-mail e senha.",

  Configuration:
    "Erro de configuração na autenticação. Verifique suas credenciais ou entre em contato com o administrador.",

  OAuthAccountNotLinked: "E-mail já em uso com outro provedor de autenticação.",

  OAuthSignin: "Erro ao fazer login com o provedor OAuth. Tente novamente.",

  OAuthCallback:
    "Erro ao processar callback do provedor OAuth. Tente novamente.",

  OAuthCreateAccount:
    "Erro ao criar conta com provedor OAuth. Tente novamente.",

  EmailCreateAccount: "Erro ao criar conta com e-mail. Tente novamente.",

  Callback: "Erro no processo de callback. Tente novamente.",

  OAuthSignInError: "Erro ao fazer login com provedor OAuth. Tente novamente.",

  SessionRequired: "Sessão necessária. Faça login novamente.",

  Default: "Erro ao fazer login. Tente novamente.",
};

/**
 * Obtém mensagem de erro amigável baseada no código de erro
 * @param errorCode Código do erro retornado pelo NextAuth
 * @returns Mensagem amigável para o usuário
 */
export function getAuthErrorMessage(errorCode?: string | null): string {
  if (!errorCode) {
    return AUTH_ERROR_MESSAGES.Default;
  }

  return AUTH_ERROR_MESSAGES[errorCode] || AUTH_ERROR_MESSAGES.Default;
}
